import { CustomFieldType } from "@/shared/domain/customFields";

import {
  roboqlComparatorsByType,
  type RoboqlComparatorsByType,
} from "./roboqlFields";

// The generated per-type comparator sets are keyed by RoboQL field-type name,
// which lines up with `CustomFieldType` except that a timestamp field's
// comparators live under the `datetime` key.
const COMPARATOR_KEY_BY_CUSTOM_FIELD_TYPE: Record<
  CustomFieldType,
  keyof RoboqlComparatorsByType
> = {
  [CustomFieldType.String]: "string",
  [CustomFieldType.Number]: "number",
  [CustomFieldType.Timestamp]: "datetime",
  [CustomFieldType.Boolean]: "boolean",
  [CustomFieldType.Enum]: "enum",
};

/**
 * Resolves the comparator allow-list for a custom field of the given type.
 *
 * Custom fields reuse the backend's general per-type comparator set — the
 * same set first-party and metadata fields of that type use — not a
 * custom-field-specific one.
 */
export function comparatorsForCustomFieldType(type: CustomFieldType): string[] {
  return roboqlComparatorsByType[COMPARATOR_KEY_BY_CUSTOM_FIELD_TYPE[type]];
}
